import '@mantine/carousel/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import 'survey-core/survey-core.css';
import App from './App.tsx';
import { theme } from './global/style/theme.tsx';

import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import './global/notifications/setupNotifications';
import 'dayjs/locale/fr';
import i18n from 'i18next';
import { Provider } from 'mobx-react';
import { StrictMode } from 'react';
import TermsAcceptanceGuard from './global/component/organism/TermsAcceptanceGuard/TermsAcceptanceGuard.tsx';
import { NavigationContextProvider } from './global/provider/navigationContext.tsx';
import { SessionContextProvider } from './global/provider/sessionContext.tsx';
import { FeatureVisibilityProvider } from './global/provider/featureVisibilityContext.tsx';
import { ThirdPartyScriptManager } from './global/services/thirdPartyScriptManager.ts';
import { stores } from './global/Store/Store.ts';
import MantineOverride from './global/style/MantineOverride.tsx';

// Initialize third-party scripts based on cookie consent
ThirdPartyScriptManager.loadAnalyticsScripts();

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
  });
}

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider {...stores}>
      <SessionContextProvider>
        <QueryClientProvider client={queryClient}>
          <FeatureVisibilityProvider>
            <NavigationContextProvider>
              <MantineProvider theme={theme}>
                <MantineOverride />
                <DatesProvider settings={{ locale: i18n.language }}>
                  <ModalsProvider>
                    <Notifications position="top-center" />
                    <TermsAcceptanceGuard>
                      <App />
                    </TermsAcceptanceGuard>
                  </ModalsProvider>
                </DatesProvider>
              </MantineProvider>
            </NavigationContextProvider>
          </FeatureVisibilityProvider>
        </QueryClientProvider>
      </SessionContextProvider>
    </Provider>
  </StrictMode>,
);
